const DETAIL_ERROR_CAUSES = {
  NECESSARY_FIELDS_MISSING: 'NECESSARY_FIELDS_MISSING',
  INVALID_FIELD_VALUE: 'INVALID_FIELD_VALUE',
  INVALID_DATABASE_TYPE: 'INVALID_DATABASE_TYPE',
  INVALID_DETAIL_TYPE: 'INVALID_DETAIL_TYPE',
  INVALID_TARGET: 'INVALID_TARGET',
};

export class InvalidTargetError extends Error {
  cause = DETAIL_ERROR_CAUSES.INVALID_TARGET;

  targetId: string;

  constructor({ targetId }: { targetId: string }) {
    super();
    this.targetId = targetId;
  }
}

export class FieldMissingError extends Error {
  cause = DETAIL_ERROR_CAUSES.NECESSARY_FIELDS_MISSING;

  value: string;
  type?: string;

  constructor({ value, type }: { value: string; type?: string }) {
    super(value);
    this.value = value;
    this.type = type || '';
  }
}

export class InvalidFieldValueError extends Error {
  cause = DETAIL_ERROR_CAUSES.INVALID_FIELD_VALUE;

  field: string;
  type: string;

  constructor({ field, type, message }: { field: string; type?: string; message: string }) {
    super(message);
    this.field = field;
    this.type = type || '';
  }
}

export class InvalidDatabaseTypeError extends Error {
  cause = DETAIL_ERROR_CAUSES.INVALID_DATABASE_TYPE;

  dbType: string;

  constructor({ dbType }: { dbType: string }) {
    super();
    this.dbType = dbType;
  }
}

export class InvalidDetailTypeError extends Error {
  cause = DETAIL_ERROR_CAUSES.INVALID_DETAIL_TYPE;

  detailType: string;

  constructor({ detailType }: { detailType: string }) {
    super();
    this.detailType = detailType;
  }
}
